const { registerBlockType } = wp.blocks;
import { InspectorControls, MediaPlaceholder, BlockIcon, BlockControls, MediaUploadCheck, MediaUpload, AlignmentToolbar, PanelColorSettings, FontSizePicker } from '@wordpress/block-editor';
import { PanelBody, ToolbarGroup, ToolbarButton, ToggleControl, RangeControl, SelectControl, TextControl, BaseControl, __experimentalBoxControl as BoxControl, __experimentalBorderBoxControl as BorderBoxControl, __experimentalInputControl as InputControl, TextareaControl } from "@wordpress/components";
const { __ } = wp.i18n;
import {fontfamilylist} from "./lib/fontfamilylist.js";
const fontSizes=[
	{
		name: 'Tiny',
		slug: 'tiny',
		size: 8,
	},
	{
		name: 'Small',
		slug: 'small',
		size: 12,
	},
	{
		name: 'Normal',
		slug: 'normal',
		size: 16,
	},
	{
		name: 'Big',
		slug: 'big',
		size: 26,
	},
	{
		name: 'Bigger',
		slug: 'bigger',
		size: 30,
	},
	{
		name: 'Huge',
		slug: 'huge',
		size: 36,
	},
];
const fallbackTitleFontSize = 20;
registerBlockType('spice-blocks/spice-img-accordion',{
    title:__('Image Accordion','spice-blocks'),
    category:'spice-blocks',
    icon: <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" aria-hidden="true" focusable="false"><path stroke="#09A223" fill="#09A223" d="M20.2 8v11c0 .7-.6 1.2-1.2 1.2H6v1.5h13c1.5 0 2.7-1.2 2.7-2.8V8h-1.5zM18 16.4V4.6c0-.9-.7-1.6-1.6-1.6H4.6C3.7 3 3 3.7 3 4.6v11.8c0 .9.7 1.6 1.6 1.6h11.8c.9 0 1.6-.7 1.6-1.6zM4.5 4.6c0-.1.1-.1.1-.1h11.8c.1 0 .1.1.1.1V12l-2.3-1.7c-.3-.2-.6-.2-.9 0l-2.9 2.1L8 11.3c-.2-.1-.5-.1-.7 0l-2.9 1.5V4.6zm0 11.8v-1.8l3.2-1.7 2.4 1.2c.2.1.5.1.8-.1l2.8-2 2.8 2v2.5c0 .1-.1.1-.1.1H4.6c0-.1-.1-.2-.1-.2z"></path></svg>,
    keywords: [
        __('Spice Image Accordion','spice-blocks'),
        __('Image Accordion','spice-blocks'),
        __('Accordion','spice-blocks')
     ],
     example: {
		"attributes": {
			"beforeImageUrl": "https://i.postimg.cc/v8WNPMGL/home-before.jpg",
			"afterImageUrl": "https://i.postimg.cc/m2B6JqDx/home-after.jpg"
		}
	},
    attributes: {
        uniqueId:{
            type:'string'
        },
        images: {
            type:'array',
            default: []
        },
        alignment: {
            type: 'string',
            default: 'center'
        },
        displayCaption: {
            type:'boolean',
            default:true
        },
        margin:{
            type:'number',
            default:5
        },
        sectionMargin: {
            default: {
                top: '0px',
                right: 'auto',
                bottom: '0px',
                left: 'auto'
            }
        },
        titlePaddings: {
            default: {
                top: '0',
                right: '0',
                bottom: '40px',
                left: '0'
            }
        },
        sectionPaddings: {
            default: {
                top: '4px',
                right: '0',
                bottom: '14px',
                left: '0'
            }
        },
        hshadow: {
            type: 'number',
            default: 0
        },
        vshadow: {
            type: 'number',
            default: 0
        },
        blurshadow: {
            type: 'number',
            default: 0
        },
        animation:{
            type:'string',
            default:''
        },
        durations:{
            type:'string',
            default:' '
        },
        delay:{
            type:'string',
        },
        hidedesktop:{
            type:'boolean',
            default:true
        },
        hidetablet:{
            type:'boolean',
            default:true
        },
        hidemobile:{
            type:'boolean',
            default:true
        },
        captionColor:{
            type:'string',
            default:'#fff'
        },
        backgroundColor:{
            type:'string',
            default:'linear-gradient(0deg,#000 0,rgba(255,255,255,0) 100%)'
        },
        shadowColor:{
            type:'string',
            default:'#777777'
        },
        opacity:{
            type:'number',
            default:1
        },
        captionFontFamily:{
            type:'string',
            default:'Open Sans'
        },
        captionFontSize:{
            type:'string',
            default:'24px'
        },
        captionFontWeight:{
            type:'string',
            default:'700'
        },
        captionlineHeight:{
            type:'number',
            default: 30
        },
        captionTxtTransform:{
            type:'string'
        },
        captionTxtDecoration:{
            type:'string'
        },
        captionLetterSpacing:{
            type:'number'
        },
        addclass:{
            type:'string',
        },
        customcss:{
            type:'string',
        }
    },
    edit: function(props){
            const { attributes, setAttributes,clientId } = props;
            setAttributes({ uniqueId: 'accordion-id' +clientId.slice(0,8) });
            const hasImages = props.attributes.images.length > 0;
            const{ uniqueId, alignment, displayCaption, margin, sectionMargin, sectionPaddings, titlePaddings, hshadow, vshadow, blurshadow, animation, durations, delay, hidedesktop, hidetablet, hidemobile, captionColor, backgroundColor, shadowColor, opacity, captionFontFamily, captionFontSize, captionFontWeight, captionlineHeight, captionTxtTransform, captionTxtDecoration, captionLetterSpacing, addclass, customcss } = attributes;

            const displaydesktop=(hidedesktop == false) ? 'hide-desktop' : '';
            const displaytablet=(hidetablet == false)   ? 'hide-tablet' : '';
            const displaymobile=(hidemobile == false)   ? 'hide-mobile' : '';
            const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;

            const animationclass='wow animated '+attributes.durations+' '+attributes.animation;

            if(captionFontFamily !=null){
                let url = 'https://fonts.googleapis.com/css2?family='+captionFontFamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
                 let link = document.createElement('link')
                  link.href = url;
                  link.rel = "stylesheet";
                  link.type =  "text/css";
                  
                  if ( jQuery("body").hasClass("site-editor-php") ) { 
                  jQuery('iframe').contents().find("head").append(link);
              }
              else{
                  document.head.appendChild(link);
              }
            } 
           
            return([<>
                    <style dangerouslySetInnerHTML={{
                    __html:[
                        `#${uniqueId} .accordian-tab{
                            margin-left: ${margin}px;
                            margin-right: ${margin}px;
                        }
                        #${uniqueId}{
                            box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
                            margin: ${sectionMargin.top} ${sectionMargin.right ? sectionMargin.right: 'auto'} ${sectionMargin.bottom} ${sectionMargin.left ? sectionMargin.left: 'auto'};
                            padding: ${sectionPaddings.top} ${sectionPaddings.right} ${sectionPaddings.bottom} ${sectionPaddings.left};
                        }
                        #${uniqueId} h3{
                            padding: ${titlePaddings.top} ${titlePaddings.right} ${titlePaddings.bottom} ${titlePaddings.left};
                            color: ${captionColor};
                            font-size: ${captionFontSize};
                            font-family: ${captionFontFamily};
                            font-weight: ${captionFontWeight};
                            text-transform: ${captionTxtTransform};
                            text-decoration: ${captionTxtDecoration};
                            line-height: ${captionlineHeight}px;
                            letter-spacing: ${captionLetterSpacing}px;
                            text-align: ${alignment};
                            margin:0;
                            
                        }
                        #${uniqueId} .accordian-tab::before{
                            background-color: ${backgroundColor};
                            opacity: ${opacity};
                        }
                        #${uniqueId} .accordian-tab:hover::before{
                            opacity: ${opacity};
                        }
                        ${customcss}
                        `
                    ].join('\n')
                }}>
                    </style>
                    <InspectorControls>
                        <PanelBody initialOpen={true} title={__('General Settings','spice-blocks')}>
                            <ToggleControl
                                label={__('Enable/Disable Caption','spice-blocks')}
                                checked={displayCaption}
                                onChange={(userVal) => setAttributes({ displayCaption: userVal })}
                            />
                            <RangeControl
                                label={__('Gutter Margin','spice-blocks')}
                                value={margin}
                                onChange={(userVal) => props.setAttributes({margin:userVal})}
                                min={0}
                                max={100}
                                step={1}
                            />
                            <PanelBody initialOpen={false} title={__('Spacing','spice-blocks')} className={'spice-panel-edit margin'}>
                                <BoxControl 
                                    label={__('Section Margin','spice-blocks')}
                                    values={sectionMargin}
                                    sides={['top', 'right','bottom','left']}
                                    allowReset={false}
                                    inputProps={{ min: -300 }}
                                    units={[]}
                                    onChange={(userVal) => setAttributes({
                                        sectionMargin:{
                                            top:userVal.top,
                                            right:userVal.right,
                                            bottom:userVal.bottom,
                                            left:userVal.left
                                        }
                                    })}
                                /> 
                                <BoxControl 
                                    label={__('Section Padding','spice-blocks')}
                                    values={sectionPaddings}
                                    sides={['top', 'right','bottom','left']}
                                    allowReset={false}
                                    units={[]}
                                    onChange={(userVal) => setAttributes({
                                        sectionPaddings:{
                                            top:userVal.top,
                                            right:userVal.right,
                                            bottom:userVal.bottom,
                                            left:userVal.left
                                        }
                                    })}
                                />
                                <BoxControl 
                                    label={__('Caption Padding','spice-blocks')}
                                    values={titlePaddings}
                                    sides={['top', 'bottom','left','right']}
                                    allowReset={false}
                                    units={[]}
                                    onChange={(userVal) => setAttributes({
                                        titlePaddings:{
                                            top:userVal.top,
                                            right:userVal.right,
                                            bottom:userVal.bottom,
                                            left:userVal.left
                                        }
                                    })}
                                />     
                            </PanelBody>
                             
                            <PanelBody initialOpen={false} title={__('Animation Effect','spice-blocks')} className={'spice-panel-edit margin'}>
                                <SelectControl
                                    label={__('Animation','spice-blocks')}
                                    value={ animation }
                                    options={ [
                                                { label: __('None','spice-blocks'), value: ' ' },
                                                { label: __('Bounce','spice-blocks'), value: 'bounce' },
                                                { label: __('Flash','spice-blocks'), value: 'flash' },
                                                { label: __('Pulse','spice-blocks'), value: 'pulse' },
                                                { label: __('RubberBand','spice-blocks'), value: 'rubberBand' },
                                                { label: __('Shake','spice-blocks'), value: 'shake' },
                                                { label: __('Swing','spice-blocks'), value: 'swing' },
                                                { label: __('Tada','spice-blocks'), value: 'tada' },
                                                { label: __('Wobble','spice-blocks'), value: 'wobble' },
                                                { label: __('Jello','spice-blocks'), value: 'jello' },
                                                { label: __('BounceIn','spice-blocks'), value: 'bounceIn' },
                                                { label: __('BounceInDown','spice-blocks'), value: 'bounceInDown' },
                                                { label: __('BounceInLeft','spice-blocks'), value: 'bounceInLeft' },
                                                { label: __('BounceInRight','spice-blocks'), value: 'bounceInRight' },
                                                { label: __('BounceInUp','spice-blocks'), value: 'bounceInUp' },
                                                { label: __('FadeIn','spice-blocks'), value: 'fadeIn' },
                                                { label: __('FadeInDown','spice-blocks'), value: 'fadeInDown' },
                                                { label: __('FadeInDownBig','spice-blocks'), value: 'fadeInDownBig' },
                                                { label: __('FadeInLeft','spice-blocks'), value: 'fadeInLeft' },
                                                { label: __('FadeInLeftBig','spice-blocks'), value: 'fadeInLeftBig' },
                                                { label: __('FadeInRight','spice-blocks'), value: 'fadeInRight' },
                                                { label: __('FadeInRightBig','spice-blocks'), value: 'fadeInRightBig' },
                                                { label: __('FadeInUp','spice-blocks'), value: 'fadeInUp' },
                                                { label: __('FadeInUpBig','spice-blocks'), value: 'fadeInUpBig' },
                                                { label: __('Flip','spice-blocks'), value: 'flip' },
                                                { label: __('FlipInX','spice-blocks'), value: 'flipInX' },
                                                { label: __('FlipInY','spice-blocks'), value: 'flipInY' },
                                                { label: __('LightSpeedIn','spice-blocks'), value: 'lightSpeedIn' },
                                                { label: __('RollIn','spice-blocks'), value: 'rollIn' },
                                                { label: __('RotateIn','spice-blocks'), value: 'rotateIn' },
                                                { label: __('RotateInDownLeft','spice-blocks'), value: 'rotateInDownLeft' },
                                                { label: __('RotateInDownRight','spice-blocks'), value: 'rotateInDownRight' },
                                                { label: __('RotateInUpLeft','spice-blocks'), value: 'rotateInUpLeft' },
                                                { label: __('RotateInUpRight','spice-blocks'), value: 'rotateInUpRight' },
                                                { label: __('SlideInDown','spice-blocks'), value: 'slideInDown' },
                                                { label: __('SlideInLeft','spice-blocks'), value: 'slideInLeft' },
                                                { label: __('SlideInRight','spice-blocks'), value: 'slideInRight' },
                                                { label: __('ZoomIn','spice-blocks'), value: 'zoomIn' },
                                                { label: __('ZoomInDown','spice-blocks'), value: 'zoomInDown' },
                                                { label: __('ZoomInLeft','spice-blocks'), value: 'zoomInLeft' },
                                                { label: __('ZoomInRight','spice-blocks'), value: 'zoomInRight' },
                                                { label: __('ZoomInUp','spice-blocks'), value: 'zoomInUp' }
                                            ] }
                                    onChange={ (newtext) => setAttributes({ animation: newtext }) }					  
                                />  
                                { animation !='' && (<>
                                <SelectControl
                                    label={__('Durations','spice-blocks')}
                                    value={ durations }
                                    options={ [
                                                { label: __('Normal','spice-blocks'), value: ' '    },
                                                { label: __('Slow','spice-blocks'),   value: 'slow' },
                                                { label: __('Fast','spice-blocks'),   value: 'fast' },
                                            ] }
                                    onChange={ (newtext) => setAttributes({ durations: newtext }) }					  
                                />  
                                <TextControl
                                    label={__('Delay(ms)','spice-blocks')}			    
                                    value={delay}
                                    onChange={(newtext) => setAttributes({ delay: newtext })}
                                />
                                </>)}
                            </PanelBody>

                            <PanelBody initialOpen={false} title={__('Display','spice-blocks')} className={'spice-panel-edit margin'}>					
                                <ToggleControl
                                    label={__('Enable/Disable on Desktop','spice-blocks')}
                                        checked={hidedesktop}
                                    onChange={(newval) => setAttributes({ hidedesktop: newval })}
                                />
                                <ToggleControl
                                    label={__('Enable/Disable on Tablet','spice-blocks')}
                                        checked={hidetablet}
                                    onChange={(newval) => setAttributes({ hidetablet: newval })}
                                />
                                <ToggleControl
                                    label={__('Enable/Disable on Mobile','spice-blocks')}
                                        checked={hidemobile}
                                    onChange={(newval) => setAttributes({ hidemobile: newval })}
                                />
                            </PanelBody>
                        </PanelBody>  
                        <PanelBody initialOpen={false} title={__('Box Shadow','spice-blocks')} className={'spice-block-side-margin'}>	
                                <RangeControl 
                                    label={__('Horizontal Shadow(px)','spice-blocks')}			    
                                    value={ hshadow}
                                    onChange={(userVal) => setAttributes({ hshadow: userVal })}
                                    min={0}
                                    max={100}
                                />
                                <RangeControl 
                                    label={__('Vertical Shadow(px)','spice-blocks')}			    
                                    value={ vshadow}
                                        onChange={(userVal) => setAttributes({ vshadow: userVal })}
                                    min={0}
                                    max={100}
                                />	
                                <RangeControl 
                                    label={__('Blur Shadow(px)','spice-blocks')}			    
                                    value={ blurshadow}
                                    onChange={(userVal) => setAttributes({ blurshadow: userVal })}
                                    min={0}
                                    max={100}
                                />
                                <PanelColorSettings initialOpen={false} className={"spice-block-color-tab-panel"}
                                    title={__('Background & Color Settings','spice-blocks')}
                                    colorSettings={[
                                        {
                                            value: shadowColor,
                                            enableAlpha:true,
                                            onChange: (colors) => setAttributes({ shadowColor: colors }),
                                            label: __('Box Shadow','spice-blocks')
                                        },
                                    ]}
                                />
                        </PanelBody> 
                        <PanelBody initialOpen={false} title={__('Color Settings','spice-blocks')}>
                            <PanelColorSettings initialOpen={false} className={"spice-block-color-tab-panel"}
                                title={__('Background & Color Settings','spice-blocks')}
                                colorSettings={[
                                    {
                                        value: captionColor,
                                        enableAlpha:true,
                                        onChange: (colors) => setAttributes({ captionColor: colors }),
                                        label: __('Caption','spice-blocks')
                                    },
                                    {
                                        value: backgroundColor,
                                        enableAlpha:true,
                                        onChange: (colors) => setAttributes({ backgroundColor: colors }),
                                        label: __('Background','spice-blocks')
                                    },
                                    
                                ]}
                            />
                            <PanelBody>
                                <RangeControl 
                                        label={__('Background Opacity','spice-blocks')}
                                        value={opacity}
                                        onChange={(onOverlayOpacityChange) =>
                                        props.setAttributes({opacity:onOverlayOpacityChange})}
                                        min={0}
                                        max={1}
                                        step={0.01}
                                />
                            </PanelBody>
                        </PanelBody>
                        <PanelBody initialOpen={false} title={__('Typography','spice-blocks')}>
                            <SelectControl
                                label={__(' Font Family','spice-blocks')}
                                value={ captionFontFamily }
                                options={fontfamilylist}
                                onChange={ (newtext) => setAttributes({ captionFontFamily: newtext }) }
                            />
                            
                            <FontSizePicker 
                                fontSizes={ fontSizes }
                                value={ captionFontSize }
                                fallbackFontSize={ fallbackTitleFontSize }
                                onChange={(userVal) => setAttributes({captionFontSize: userVal})}
                                allowReset={false}
                            />

                            <SelectControl
                                label={__('Font Weight','spice-blocks')}
                                options= {[
                                    { label: __('Thin','spice-blocks'), value: '100' },
                                    { label: __('Extra Light','spice-blocks'), value: '200' },
                                    { label: __('Light','spice-blocks'), value: '300' },
                                    { label: __('Regular','spice-blocks'), value: '400' },
                                    { label: __('Medium','spice-blocks'), value: '500' },
                                    { label: __('Semi Bold','spice-blocks'), value: '600' },
                                    { label: __('Bold','spice-blocks'), value: '700' },
                                    { label: __('Extra Bold','spice-blocks'), value: '800' },
                                    { label: __('Black','spice-blocks'), value: '900' }
                                ]}
                                value={captionFontWeight}
                                onChange={ (userVal) => setAttributes({ captionFontWeight: userVal }) }
                            />

                            <RangeControl 
                                label={__('line Height(px)','spice-blocks')}
                                value={captionlineHeight}
                                min={0}
                                max={100}
                                onChange={(userVal) => setAttributes({captionlineHeight: userVal})}
                            />

                            <SelectControl
                                label={__('Text Transform','spice-blocks')}
                                options={[
                                    { label: __('Default','spice-blocks'), value: '' },
                                    { label: __('Uppercase','spice-blocks'), value: 'uppercase' },
                                    { label: __('Lowercase','spice-blocks'), value: 'lowercase' },
                                    { label: __('Capitalize','spice-blocks'), value: 'capitalize' }
                                ]}
                                value={captionTxtTransform}
                                onChange={(userVal) => setAttributes({captionTxtTransform:userVal})}
                            />

                            <SelectControl 
                                label={__('Text Decoration','spice-blocks')}
                                options={[
                                    { label: __('Default','spice-blocks'), value: '' },
                                    { label: __('Underline','spice-blocks'), value: 'underline' },
                                    { label: __('Overline','spice-blocks'), value: 'overline' },
                                    { label: __('Line Through','spice-blocks'), value: 'line-through' }
                                ]}
                                value={captionTxtDecoration}
                                onChange={(userVal) => setAttributes({captionTxtDecoration:userVal})}
                            />

                            <RangeControl 
                                label={__('Letter Spacing','spice-blocks')}
                                value={captionLetterSpacing}
                                min={-10.0}
                                max={10.0}
                                onChange={(userVal)=> setAttributes({captionLetterSpacing:userVal})}
                            />
                        </PanelBody>

                        <PanelBody initialOpen={false} title={__('Additional Settings','spice-blocks')}>
                            <InputControl
                                label={__('Additional Class','spice-blocks')}
                                value={ addclass }
                                onChange={ (userVal)=> setAttributes({addclass:userVal}) }
                            />
                            <TextareaControl
                                label={__('Custom CSS','spice-blocks')}
                                value={ customcss }
                                onChange={ (userVal)=> setAttributes({customcss:userVal}) }
                            />
                        </PanelBody>
                    
                    </InspectorControls>

                    <div className={`spice-block-img-accordian-container ${animationclass} ${displayclass} ${addclass}`} style={{ animationDelay: delay+ 'ms'}}  id={uniqueId}>
                    {hasImages && [
                        <div class="accordian-row">
                            {props.attributes.images.map((image, index) => (
                                <div className={`accordian-tab tab-1 ${image.alt}`}>
                                    <img key={index} src={image.url} alt={image.alt} data-id={ image.id } data-link={ image.link } />
                                    <div class="accordian-content">
                                        <div class="social-icon">
                                           
                                        </div>
                                       { displayCaption == true && [ <h3>{image.caption}</h3> ]}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ]}
                    </div>
                    {!hasImages && [
                        <MediaPlaceholder
                            multiple
                            gallery
                            addToGallery={true}
                            icon={<BlockIcon icon="format-gallery" />}
                            onSelect={(newImages) => props.setAttributes({ images: newImages })}
                            allowedTypes={["image"]}
                            value={props.attributes.images.map((image) => image.id)}
                            labels={{title: "Image Accordion", instructions: "Upload Images For Image Accordion."}}
                        /> 
                    ]}   
                    <BlockControls>
                        <ToolbarGroup>
                            <MediaUploadCheck>
                                <MediaUpload
                                    multiple
                                    gallery
                                    addToGallery={true}
                                    onSelect={(newImages) =>
                                        props.setAttributes({ images: newImages })}
                                    allowedTypes={["image"]}
                                    value={props.attributes.images.map((image) => image.id)}
                                    render={({ open }) => (
                                        <ToolbarButton onClick={open}>
                                            {__("Edit Image Accordion", "Create Image Accordion")}
                                        </ToolbarButton>)}
                                />
                            </MediaUploadCheck>
                        </ToolbarGroup>
                        <AlignmentToolbar
                            value={alignment}
                            onChange={(newalign) => setAttributes({ alignment: newalign })}
                        />	
                    </BlockControls>
                </>])
    },
    save: function({attributes}){
            const{ uniqueId, alignment, displayCaption, margin, sectionMargin, sectionPaddings, titlePaddings, hshadow, vshadow, blurshadow, animation, durations, delay, hidedesktop, hidetablet, hidemobile, captionColor, backgroundColor, shadowColor, opacity, captionFontFamily, captionFontSize, captionFontWeight, captionlineHeight, captionTxtTransform, captionTxtDecoration, captionLetterSpacing, addclass, customcss } = attributes;

            const displaydesktop=(hidedesktop == false) ? 'hide-desktop' : '';
            const displaytablet=(hidetablet == false)   ? 'hide-tablet' : '';
            const displaymobile=(hidemobile == false)   ? 'hide-mobile' : '';
            const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;

            const animationclass='animated '+attributes.durations+' '+attributes.animation;
            return(<>
                    <script>
                        var titleFamily=`{captionFontFamily}`;
                        var url = 'https://fonts.googleapis.com/css2?family='+titleFamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
                        var link = document.createElement('link');
                        link.href = url;
                        link.rel = "stylesheet";
                        link.type =  "text/css";	          
                        document.head.appendChild(link);
                    </script>
                    <style dangerouslySetInnerHTML={{
                        __html:[
                            `#spice-${uniqueId} .accordian-tab{
                                margin-left: ${margin}px;
                                margin-right: ${margin}px;
                            }
                            #spice-${uniqueId}{
                                box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
                                margin: ${sectionMargin.top} ${sectionMargin.right ? sectionMargin.right : 'auto'} ${sectionMargin.bottom} ${sectionMargin.left ? sectionMargin.left : 'auto'};
                                padding: ${sectionPaddings.top} ${sectionPaddings.right} ${sectionPaddings.bottom} ${sectionPaddings.left};
                            }
                            #spice-${uniqueId} h3{
                                padding: ${titlePaddings.top} ${titlePaddings.right} ${titlePaddings.bottom} ${titlePaddings.left};
                                color: ${captionColor};
                                font-size: ${captionFontSize};
                                font-family: ${captionFontFamily};
                                font-weight: ${captionFontWeight};
                                text-transform: ${captionTxtTransform};
                                text-decoration: ${captionTxtDecoration};
                                line-height: ${captionlineHeight + 'px'};
                                letter-spacing: ${captionLetterSpacing}px;
                                text-align: ${alignment};
                                margin:0;
                            }
                            #spice-${uniqueId} .accordian-tab::before{
                                background-color: ${backgroundColor};
                                opacity: ${opacity};
                            }
                            #spice-${uniqueId} .accordian-tab:hover::before{
                                opacity: ${opacity};
                            }
                            ${customcss}
                            `
                        ].join('\n')
                    }}>

                    </style>
                    <div className={`spice-block-img-accordian-container ${animationclass} ${displayclass} ${attributes.className} ${addclass}`} style={{ animationDelay: delay+ 'ms'}}  id={`spice-${uniqueId}`}>
                        <div class="accordian-row">
                            {attributes.images.map((image, index) => (
                                <div className={`accordian-tab tab-1 ${image.alt}`}>
                                    <img key={index} src={image.url} alt={image.alt} data-id={ image.id } data-link={ image.link } />
                                    <div class="accordian-content">
                                        <div class="social-icon">
                                           
                                        </div>
                                       { displayCaption == true && [ <h3>{image.caption}</h3> ]}
                                    </div>
                                </div>
                            ))}
                        </div>
                    
                    </div>
                </>)
    }
})